// extracted by mini-css-extract-plugin
export default {"title":"maa-z","warning":"naa-z","sizeOptionsLegendText":"oaa-z"};